module.exports = __webpack_public_path__ + "static/Gotham-Medium-dd4c4b2276b198deecbc7a090e9810c2.ttf";